import uiCore = require("../core/uicore");

export class PdfReportViewerSinglePageDirective implements uiCore.IDirective {

    static link(scope, element: HTMLElement[], _attrs) {
        var self = <PdfReportViewerSinglePageDirective>scope.vm;

        self._canvas = <any>(element[0].childNodes[0]);
        self.readPage(scope);
    }

    public static ComponentDescription: uiCore.IStandardComponentDescription = {
        DirectiveId: "crewpdfviewersinglepage",
        Template: require("./crewpdfviewersinglepage.html"),
        AngularDependencies: [uiCore.ScopeDependency],
        Bindings: {
            pageindex: "=",
            scale: "=",
            pdf: "=",
        },
        Link: PdfReportViewerSinglePageDirective.link
    }
    
    _canvas: HTMLElement;

    private _page;

    public pageindex: number;
    public scale: number;
    public pdf: any;

    readPage(scope: any) {
        if (this.pdf) {
            this.pdf.getPage(this.pageindex)
                .then(page => {
                    this._page = page;
                    this.renderPage();

                    // Listen for scale change
                    scope.$watch("vm.scale", this.onScaleChanged);
                });
        }
    }

    renderPage() {
        if (this._page) {
            var viewport = this._page.getViewport(this.scale);
            var canvas = <any>this._canvas;
            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            this._page.render(renderContext);
        }
    }

    onScaleChanged = (newValue, oldValue) => {
        if (newValue != oldValue) {
            this.renderPage();
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/crewpdfviewersinglepage.ts